module.exports = __webpack_public_path__ + "vu.svg?23d9b689d94733497f4e5be5004f1892";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/1x1/vu.svg
// module id = 1168
// module chunks = 27